import { memo } from "react";
import { clsx } from "clsx";

import MostPopularSparklesIcon from "@/shared/assets/graphics/mostpopularsparkles.svg";

import cls from "./MostPopular.module.scss";

interface MostPopularProps {
  position?: "left" | "center";
  variant?: "light" | "dark";
  text?: string;
}

export const MostPopular = memo<MostPopularProps>((props) => {
  const { position = "center", variant = "dark", text = "MOST POPULAR" } = props;

  return (
    <div className={clsx(cls.MostPopular, cls[variant], position === "left" && cls.leftSide)}>
      <div className={cls.Tag}>
        <MostPopularSparklesIcon width={16} height={16} />
        {text}
      </div>
    </div>
  );
});
